import { handleError } from '@common/utils/handleError';

class ShopifyClient {
	apiUrl: string;

	apiAccessToken: string;

	constructor(apiUrl: string, apiAccessToken: string) {
		this.apiUrl = apiUrl;
		this.apiAccessToken = apiAccessToken;
	}

	async request<T>(query: string, variables?: Record<string, unknown>) {
		const response = await fetch(this.apiUrl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-Shopify-Storefront-Access-Token': this.apiAccessToken,
			},
			body: JSON.stringify({ query, variables }),
		});

		if (!response.ok) {
			handleError(`Shopify request failed with status ${response.status}`);
		}

		const result: { data: T; errors: unknown[] } = await response.json();

		if (result.errors) {
			handleError(`Shopify request failed with errors}`);
		}

		return result.data;
	}
}

export const shopifyClient = new ShopifyClient(
	process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_URL || '',
	process.env.NEXT_PUBLIC_SHOPIFY_STOREFRONT_API_ACCESS_TOKEN || '',
);
